import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

// 1. Properly type the props
interface FormSubmissionGuardProps {
  children: ReactNode;
}

// 2. Explicit return type annotation
const FormSubmissionGuard: React.FC<FormSubmissionGuardProps> = ({
  children,
}): React.JSX.Element | null => {
  const isFormSubmitted = useSelector((state: RootState) => state.formSubmitted.isFormSubmitted);

  // 3. Always return valid React elements or null
  if (!isFormSubmitted) {
    return <Navigate to="/user/dashboard" replace />;
  }

  return <>{children}</>;
};

export default FormSubmissionGuard;
